import React from 'react'

function Heart ({ className, fill }) {
  return (
    <svg fill={fill} className={className} width="34.841" height="32" viewBox="0 0 34.841 32">
      <path d="M17.42,32.168,2.95,17.7A10.31,10.31,0,0,1,10.314.168,10.3,10.3,0,0,1,17.42,3.226,10.233,10.233,0,0,1,31.891,17.7ZM10.314,1.752A8.728,8.728,0,0,0,4.078,16.589L17.42,29.931,30.773,16.579A8.728,8.728,0,0,0,24.527,1.752,8.865,8.865,0,0,0,18.014,4.9l-.594.663L16.827,4.9A8.865,8.865,0,0,0,10.314,1.752Zm0,0" transform="translate(0 -0.168)" />
    </svg>
  )
}

Heart.defaultProps = {
  className: 'w-full h-full',
  fill: 'currentColor'
}

export default Heart
